import { jsx as _jsx } from "react/jsx-runtime";
import { TS_Toggle } from './TS_Toggle.js';
import { ComponentSync } from '../../core/ComponentSync.js';
export class ATS_Toggle extends ComponentSync {
    static Screen = {
        name: 'TS Toggle',
        key: 'ts-toggle',
        group: 'TS Components',
        renderer: this,
    };
    deriveStateFromProps(nextProps, state) {
        state.checked ??= false;
        return state;
    }
    render() {
        return _jsx(TS_Toggle, { id: 'test-toggle', checked: this.state.checked, onCheck: () => this.setState({ checked: !this.state.checked }) });
    }
}
//# sourceMappingURL=ATS_Toggle.js.map